// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/go_no_go.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { DiscardGoNoGoAIDraftRequest, DiscardGoNoGoAIDraftResponse, DraftGoNoGoWithAIRequest, DraftGoNoGoWithAIResponse, GetGoNoGoEvidenceSnapshotRequest, GetGoNoGoEvidenceSnapshotResponse, ListGoNoGoRecordsRequest, ListGoNoGoRecordsResponse, RecordGoNoGoDecisionRequest, RecordGoNoGoDecisionResponse } from "./go_no_go_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * GoNoGoService is the browser edge for SAD-488 / CAP-04: evidence-backed,
 * append-only go/no-go records with reviewable AI drafts. Each RPC wraps
 * pangaea's GoNoGoRecordsGatewayService (and CaptureGatewayService for the
 * evidence reads).
 *
 * Identity: tenant_id and the acting user are ALWAYS taken from the gateway
 * principal — no request field carries them. Authorization is the
 * capture_project policy actions read_go_no_go / record_go_no_go /
 * draft_go_no_go, resolved on the pursuit's scope node.
 *
 * Invariants: records are never edited or deleted (a later decision is a new
 * row); recording a decision does NOT change the pursuit stage, close or edit
 * tasks, or touch award records; an AI draft is never a record — it is only
 * marked accepted when a human records a decision that references it.
 *
 * @generated from service mono.projectdata.v1.GoNoGoService
 */ export const GoNoGoService = {
    typeName: "mono.projectdata.v1.GoNoGoService",
    methods: {
        /**
     * GetGoNoGoEvidenceSnapshot assembles the CURRENT evidence for a pursuit
     * (nothing is persisted). Use it to review before deciding.
     *
     * @generated from rpc mono.projectdata.v1.GoNoGoService.GetGoNoGoEvidenceSnapshot
     */ getGoNoGoEvidenceSnapshot: {
            name: "GetGoNoGoEvidenceSnapshot",
            I: GetGoNoGoEvidenceSnapshotRequest,
            O: GetGoNoGoEvidenceSnapshotResponse,
            kind: MethodKind.Unary
        },
        /**
     * RecordGoNoGoDecision appends one record. The server captures the evidence
     * snapshot at record time; no meeting or due date is needed.
     *
     * @generated from rpc mono.projectdata.v1.GoNoGoService.RecordGoNoGoDecision
     */ recordGoNoGoDecision: {
            name: "RecordGoNoGoDecision",
            I: RecordGoNoGoDecisionRequest,
            O: RecordGoNoGoDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListGoNoGoRecords returns all records newest first, each flagged
     * is_current when it is the latest record for its scope.
     *
     * @generated from rpc mono.projectdata.v1.GoNoGoService.ListGoNoGoRecords
     */ listGoNoGoRecords: {
            name: "ListGoNoGoRecords",
            I: ListGoNoGoRecordsRequest,
            O: ListGoNoGoRecordsResponse,
            kind: MethodKind.Unary
        },
        /**
     * DraftGoNoGoWithAI persists a draft suggestion only; it never records.
     *
     * @generated from rpc mono.projectdata.v1.GoNoGoService.DraftGoNoGoWithAI
     */ draftGoNoGoWithAI: {
            name: "DraftGoNoGoWithAI",
            I: DraftGoNoGoWithAIRequest,
            O: DraftGoNoGoWithAIResponse,
            kind: MethodKind.Unary
        },
        /**
     * DiscardGoNoGoAIDraft dismisses an open draft.
     *
     * @generated from rpc mono.projectdata.v1.GoNoGoService.DiscardGoNoGoAIDraft
     */ discardGoNoGoAIDraft: {
            name: "DiscardGoNoGoAIDraft",
            I: DiscardGoNoGoAIDraftRequest,
            O: DiscardGoNoGoAIDraftResponse,
            kind: MethodKind.Unary
        }
    }
};
